export default {
  "igb": {
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["hello i18n !!"])},
    "main-visual": {
      "slogan": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Navegue até tesouros globais com a KUMA!"])},
        "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A solução definitiva White Label e Turnkey para o seu sucesso."])}
      },
      "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Público"])},
      "market": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["alvo"])},
      "ja": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japão"])},
      "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["América Latina"])},
      "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "pt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "zh": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "userFrontEnd": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Front-End do Usuário"])},
      "list": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desenho de Página Personalizado"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diversos Designs de Modelos Recomendados"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otimizando Páginas para Melhorar as Experiências dos Jogadores."])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HTML 5, Design Web Responsivo,Troca Multilíngue"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["20000+ Jogos Populares e Divertidos"])}
      ],
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check out the Design Template now"])}
    },
    "boi": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Interface de Operações em Segundo Plano"])},
      "text": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornece uma interface amigável para que os usuários operem, mas poderosa o suficiente para lidar com as necessidades dos usuários."])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Os usuários podem configurar todos os parâmetros para o site deles, incluindo campanhas, pagamentos, transações de jogos, CMS e mais."])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      ],
      "list": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Centro de Relatórios"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerenciamento de Jogadores"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerenciamento de Fundos"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerenciamento de Jogos"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerenciamento de Promoções"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gerenciamento de Conteúdo"])}
      ]
    },
    "advantage": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vantagem?"])},
      "content": [
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Banco de Dados"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Permite monitorar o negócio e ficar atualizado com as últimas notícias dos jogadores."])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Análise de Dados"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relatório de Análise de Operações"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relatório de Lucro"])}
          ]
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suporte 24/7"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem fuso horário entre nós quando ajuda é necessária ou problemas surgem."])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suporte Técnico"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atendimento ao Cliente"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
          ]
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Profissionais"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recrutando a melhor equipe para satisfazer suas necessidades."])},
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serviço Individualizado"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desenvolvimento de Tecnologia"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equipe de Design"])}
          ]
        }
      ]
    },
    "gameProviders": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornecedores de Jogos"])}
    },
    "payments": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagamentos"])}
    },
    "process": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Processo"])},
      "content": [
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consulta →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Consulte o produto e faça o seu plano. "])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assinatura de Contrato→"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discuta mais detalhes e assine o contrato. "])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escolha seu modelo e designs."])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Construção do Site →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Construiremos o site após confirmar o design."])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Revisão →"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifique se algo precisa ser revisado."])}
        },
        {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publicação"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hora de colocar seu site no ar!"])}
        }
      ]
    },
    "partner": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parceiro"])},
      "content": {
        "yc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resposta Rápida"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diversas Criptomoedas"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jogos Mais Recentes e Populares"])}
        ],
        "wc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seguro e Confiável"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simples para Registrar e Jogar"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suporte para Múltiplos Dispositivos"])}
        ],
        "mc": [
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boa Experiência do Usuário"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serviço Rápido de Saque/Depósito"])},
          (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promoções Populares"])}
        ]
      }
    },
    "googleForm": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contate-nos"])}
    }
  },
  "kb": {
    "eventOverview": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["毎晩19時、勝者には最大30万円相当の賞金チャンス！"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["無料で参加できるオンライン対戦イベント。<br/>未経験でも気軽に挑戦できる知的ゲームが、毎晩あなたを待っています。"])}
    },
    "tournamentDetails": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["毎日開催！<br/>戦略を試すトーナメント"])}
    },
    "eventSpecial": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このイベントが特別な理由"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["【TikTokユーザー限定！】初回参加で特別ボーナスプレゼント！"])},
      "mobile": {
        "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["【TikTokユーザー限定！】<br/>初回参加で特別ボーナスプレゼント！"])}
      }
    },
    "howtoJoin": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加はとてもシンプル！"])},
      "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参加するたびにスキルが上がる！今日の対戦相手は誰になるでしょうか？毎回異なるプレイヤーとの対戦で、新しい戦略や駆け引きを楽しめます。"])}
    },
    "heatedBattle": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["熱闘の瞬間"])},
      "smallTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「運と実力の絶妙なバランス――知的トーナメント開幕！」"])}
    },
    "growingCommunity": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次の挑戦者はあなた！"])},
      "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登録は簡単！エントリーするだけで、毎晩19時からアツいトーナメントに参加できます！"])}
    }
  },
  "km": {
    "common": {
      "page": {
        "list": {
          "launchSuite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Launch Suite"])},
          "systemCenter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["System Center"])},
          "kumaDna": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA DNA"])},
          "partnerHub": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partner Hub"])},
          "smartSupport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smart Support"])},
          "language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])}
        },
        "subList": {
          "advance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Advance"])},
          "beginner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beginner"])},
          "custom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom"])},
          "frontendOverview": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frontend Overview"])},
          "backendConsole": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Backend Console"])},
          "gameSetup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Game Setup"])},
          "KUMAOverview": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA Overview"])},
          "expoFootprints": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expo Footprints"])},
          "partnerBrands": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partner Brands"])},
          "campaignPush": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campaign Push"])},
          "tagStudio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tag Studio"])},
          "privacyPolicy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacy Policy"])}
        }
      },
      "view": {
        "contactBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact Us"])}
        },
        "partnerListBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partner List"])}
        }
      }
    },
    "component": {
      "CodeTitle": {
        "ThirdBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FromIdea"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ToLive"])}
        },
        "FourthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KeyStrengths"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BuiltByExperts"])}
        },
        "FifthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMAExclusive"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partnership"])}
        },
        "SixthBlock": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["YourQuestions"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Answers"])}
        },
        "Beginner": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand Upgrade"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next Level"])}
        },
        "BeginnerInfo": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ Answers"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upgrade with Ease"])}
        },
        "Advance": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quick Start"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Launch Steady"])}
        },
        "AdvanceInfo": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Support Anytime"])}
        },
        "Custom": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom Build"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your Way"])}
        },
        "Frontend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frontend"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear Control"])}
        },
        "Backend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Central Command"])}
        },
        "GameSetup": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Game Setup"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strategy Ready"])}
        },
        "KUMAOverview": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose KM"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grow Stronger"])}
        },
        "ExpoFootprints": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go Global"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expand Impact"])}
        },
        "PartnerBrands": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trusted Partners"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality Assured"])}
        },
        "CampaignPush": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["One-Tap Push"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Direct Reach"])}
        },
        "TagStudio": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precise Display"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Highlight Focus"])}
        }
      },
      "SubTitle": {
        "Beginner": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optimize"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grow"])}
        },
        "Advance": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpler"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faster"])}
        },
        "Custom": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unique"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reliable"])}
        },
        "Frontend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instant"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions"])}
        },
        "Backend": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unified"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decisive"])}
        },
        "GameSetup": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Flexible"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tactical"])}
        },
        "KUMAOverview": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Solid"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scalable"])}
        },
        "ExpoFootprints": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visible"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recognized"])}
        },
        "PartnerBrands": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trusted"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Evolving"])}
        },
        "CampaignPush": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simple"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Direct"])}
        },
        "TagStudio": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rich"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Flexible"])}
        }
      },
      "TabCodeSnippet": {
        "getStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Start"])},
        "scaleUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scale Up"])},
        "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Time"])},
        "design": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design"])},
        "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
        "control": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Control"])},
        "support": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Support"])},
        "customization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customization"])},
        "integration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration"])},
        "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Content"])},
        "platform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Platform"])},
        "expansion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expansion"])},
        "solutionBtn": {
          "getStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get your solution"])},
          "scaleUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unlock your full potential"])}
        }
      },
      "PlanCards": {
        "standard": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simpler & Faster"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Launch fast, no hassle"])}
        },
        "advanced": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optimize & Grow"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Better performance, scalable"])}
        },
        "custom": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unique & Reliable"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Built to fit your needs"])}
        },
        "viewPlans": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View Plans"])}
        }
      },
      "StepCards": {
        "activateIdeas": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate Ideas"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Launch your brand"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start from zero, ignite your brand"])}
        },
        "blueprintDesign": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blueprint Design"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose your site template & settings"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mix-and-match templates to craft your style"])}
        },
        "connectData": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connect Data"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrate data and automate next steps"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrate modules to automate your workflow"])}
        },
        "deployLive": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deploy Live"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test, then go live instantly"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test and optimize, then go live at full speed"])}
        }
      },
      "CircleCarousel": {
        "diverseTags": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diverse Tags"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mix trending, new, exclusive tags"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Define your own highlights"])}
          ]
        },
        "flexibleCampaigns": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Flexible Campaigns"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["One-click launch promos"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enable flexible player engagement"])}
          ]
        },
        "selfManagedOrdering": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Self-Managed Ordering"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Switch games anytime"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boost platform visibility"])}
          ]
        },
        "weeklyNewReleases": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Weekly New Releases"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New games every week"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Content stays fresh"])}
          ]
        },
        "exclusiveResources": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclusive Resources"])},
          "text": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Flexible resource model"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unique in the industry"])}
          ]
        },
        "controller": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" Exclusive advantages unlocked through partnership with KUMA "])}
        }
      },
      "FilesCards": {
        "pricing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</Pricing>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How does pricing work?"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Flexible plans with clear quotes. No hidden fees."])}
        },
        "timeline": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</Timeline>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How long from contract to go live?"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Most projects launch within weeks, depending on scope."])}
        },
        "checklist": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["</Checklist>"])},
          "question": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What do I need to prepare?"])},
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Basic company info and required materials. We’ll guide you through the process."])}
        },
        "filesCardsBtn": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get details now"])}
        }
      },
      "LetterCards": {
        "clear": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["guidance"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["through every phase."])}
        },
        "custom": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["solutions"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["tailored to your goals."])}
        },
        "curated": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Curated"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["services"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["to drive growth."])}
        },
        "collaborative": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Collaborative"])},
          "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["teamwork"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["for lasting success."])}
        }
      },
      "KUMAOverview": {
        "coreStrength": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kuma’s Core Strengths"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA’s tech foundation makes every step faster and more precise."])}
        },
        "gamingPlatform": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclusive Gaming Platform"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your vision, fully realized — every feature built for your operation."])}
        },
        "gamesAndPayments": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["One-Click Integration of Games and Payments"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KUMA ensures fast, secure connections for global operations."])}
        }
      },
      "FsLightGallery": {
        "2025G2E": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 G2E"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demonstrated a mature system architecture and operational tools, helping clients quickly understand product value and use cases."])}
        },
        "2025IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clarified key workflows and risk control through live demos, helping clients quickly grasp core value."])}
        },
        "2025SIGMA": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2025 SIGMA"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Showcased White Label and Turnkey solutions, highlighting collaboration value. Global inquiries continued to increase."])}
        },
        "2024IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2024 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shared testing scripts and optimization insights, reducing costs and improving launch efficiency."])}
        },
        "2023IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2023 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Highlighted real-time monitoring and compliance tools. On-site interactions connected tech and business, driving stronger partnerships."])}
        },
        "2022IGB": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2022 IGB"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demonstrated RWD templates and a three-step launch flow. High engagement boosted partnership opportunities."])}
        },
        "2019AWE": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2019 AWE"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our first appearance in Asia — connecting with partners, expanding perspectives, and opening new opportunities."])}
        }
      },
      "CampaignPush": {
        "display": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Display"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Display"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Across key site touchpoints"])}
        },
        "reach": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reach"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reach"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Via partners and referrals"])}
        },
        "create": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages with content and offers"])}
        },
        "optimize": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optimize"])},
          "activeTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optimize"])},
          "subTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campaign results in real time"])}
        }
      },
      "BrandGallery": {
        "slot": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slot"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slot Games"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["One tap starts the reels — fast and fun."])}
        },
        "live": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Live"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Live Games"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Real dealers, real games — easy access to Baccarat, Roulette & more."])}
        },
        "casino": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Casino"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Casino Games"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digital fun with Bingo, Racing, and interactive game styles."])}
        },
        "fishing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fishing"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shooting / Fishing"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aim, shoot, and enjoy — intuitive and fun for all players."])}
        },
        "sports": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sports"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sports"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Global sports with live odds and simple, exciting play."])}
        },
        "pachinko": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pachinko"])},
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pachinko"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A Japanese classic — drop a ball and enjoy vibrant sound and light."])}
        }
      },
      "TagGallery": {
        "hot": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hot"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drive traffic to top games"])}
        },
        "new": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keep content fresh"])}
        },
        "only": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Only"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stand out your brand"])}
        },
        "nobonus": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Bonus"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simple promo control"])}
        },
        "rebate": {
          "tag": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Rebate"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear play rules"])}
        }
      },
      "PrivacyPolicy": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Privacy Policy"])},
        "subTitle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["We respect your ", _interpolate(_named("privacy")), " and are committed to ", _interpolate(_named("protecting")), " your ", _interpolate(_named("personalData")), "."])},
        "highlight": {
          "privacy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["privacy"])},
          "protecting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["protecting"])},
          "personalData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["personal data"])}
        },
        "dataCollection": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1. Data Collection"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["When you use our contact forms, submit inquiries, or interact with the Platform in other ways, we may collect personal information you provide, such as your name, email address, and contact details."])}
        },
        "useOfInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["2. Use of Information"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We collect basic personal info to provide services and support. Your data is kept secure and used only with consent or as required by law. We do not share it with third parties without permission."])}
        },
        "dataProtection": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["3. Data Protection"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We implement reasonable technical and administrative measures to safeguard your personal data from unauthorized access, disclosure, alteration, or destruction."])}
        },
        "dataSharing": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["4. Data Sharing"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unless required by law or with your consent, we do not disclose your personal information to third parties.\nHowever, we may share necessary information with our partners to support Platform operations, and we require our partners to comply with data protection standards."])}
        },
        "policyUpdates": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["5. Policy Updates"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We reserve the right to update this Privacy Policy at any time. Updates will be published immediately on this page.\nWe recommend checking this page periodically to stay informed of any changes."])}
        }
      },
      "KeyCaps": {
        "designer": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Brand-led"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Modular templates"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Visual system"])}
          ]
        },
        "frontend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Clean UX"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Responsive"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Secure by design"])}
          ]
        },
        "backend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Scalable system"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Advanced analytics"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Risk controls"])}
          ]
        },
        "project": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Tailored rollout"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Fast delivery"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Clear milestones"])}
          ]
        },
        "support": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#24/7 service"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Global support"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Human response"])}
          ]
        }
      },
      "Marquee": {
        "launchSuite": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smooth Flow"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Steady Pace"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear Outcome"])}
          ]
        },
        "systemCenter": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instant View"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Ready"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Run Steady"])}
          ]
        },
        "kumaDNA": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Core Solid"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand Strong"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keep Growing"])}
          ]
        },
        "partnerHub": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boost Content"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lift Reach"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Grow Impact"])}
          ]
        },
        "smartSupport": {
          "list": [
            
          ]
        }
      },
      "KumaTitle": {
        "Index": {
          "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclusive"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["i-Gaming Platform"])}
        }
      },
      "KumaButton": {
        "exploreSolutions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Explore Solutions"])},
        "bookADemoNow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Book a demo now"])}
      },
      "IndexBlockSubTitle": {
        "first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How to from zero to pro. We map your steps to reality."])},
        "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["deploying top experts to build your platform."])},
        "third": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turning your blueprint into a live platform."])}
      },
      "PainList": {
        "rows": [
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No experience"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guided setup"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No idea"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear direction"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Too much jargon"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plain terms"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complicated steps"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simple steps"])}
          },
          {
            "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No one to help"])},
            "hover": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Team support"])}
          }
        ]
      },
      "DepartmentCardList": {
        "designer": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Brand-led"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Modular templates"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Visual system"])}
          ]
        },
        "frontend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Clean UX"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Responsive"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Secure by design"])}
          ]
        },
        "backend": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Scalable system"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Advanced analytics"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Risk controls"])}
          ]
        },
        "project": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Tailored rollout"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Fast delivery"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Clear milestones"])}
          ]
        },
        "support": {
          "list": [
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#24/7 service"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Global support"])},
            (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#Human response"])}
          ]
        }
      },
      "MakeCards": {
        "first": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ignite Brand"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Define your core identity from day one."])}
        },
        "second": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Craft Style"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mix and match templates for a unique look."])}
        },
        "third": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select & Integrate"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pick your partners, we handle the API integration"])}
        },
        "fourth": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Test & Launch"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optimize performance and go live instantly."])}
        }
      },
      "DiceTitle": {
        "variable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Answer"])},
        "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Question"])}
      },
      "FAQList": {
        "first": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["How long from contract to go live?"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Most projects launch within weeks, depending on scope."])}
        },
        "second": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["What do I need to prepare?"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Basic company info and required materials. We’ll guide you through the process."])}
        }
      }
    }
  },
  "kbbak": {
    
  }
}